'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { Center, Loader, Stack, Text } from '@mantine/core';
import { useAuth } from '@/hooks/useAuth';

/**
 * Root page - redirects to appropriate location based on auth status.
 * Authenticated users go to /kernels (dashboard home).
 * Unauthenticated users go to /login.
 */
export default function RootPage() {
  const { isAuthenticated, isLoading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated) {
        // Redirect to dashboard home
        router.replace('/dashboard');
      } else {
        // Redirect to login
        router.replace('/login');
      }
    }
  }, [isAuthenticated, isLoading, router]);

  return (
    <Center h="100vh">
      <Stack align="center" gap="md">
        <Loader size="lg" color="primary" />
        <Text c="dimmed">Loading...</Text>
      </Stack>
    </Center>
  );
}
